import { render, staticRenderFns } from "./LandingApp.vue?vue&type=template&id=da95f27a&scoped=true"
import script from "./LandingApp.vue?vue&type=script&lang=js"
export * from "./LandingApp.vue?vue&type=script&lang=js"
import style0 from "./LandingApp.vue?vue&type=style&index=0&id=da95f27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da95f27a",
  null
  
)

export default component.exports